/**
 * Opens the Zoho SalesIQ chat widget if it is loaded.
 * Safe to call before the deferred widget script finishes.
 */
export function openZohoChat() {
  if (typeof window === 'undefined') return;

  const showChat = () => {
    try {
      if (window.$zoho?.salesiq?.floatwindow?.visible) {
        window.$zoho.salesiq.floatwindow.visible('show');
        return true;
      }
    } catch {
      /* ignore */
    }
    return false;
  };

  if (showChat()) return;

  const priorReady = window.$zoho?.salesiq?.ready;
  window.$zoho = window.$zoho || {};
  window.$zoho.salesiq = window.$zoho.salesiq || {};
  window.$zoho.salesiq.ready = function () {
    if (typeof priorReady === 'function') priorReady();
    showChat();
  };
}
